export default __webpack_public_path__ + "static/media/Avatar.d8de308f.png";